(() => {
  const openPopup = (popup) => {
    popup.hidden = false;
    popup.classList.remove("is-closing");

    requestAnimationFrame(() => {
      popup.classList.add("is-active");
    });

    document.documentElement.style.overflow = "hidden";
  };

  const closePopup = (popup) => {
    popup.classList.remove("is-active");
    popup.classList.add("is-closing");

    setTimeout(() => {
      popup.hidden = true;
      popup.classList.remove("is-closing");
      document.documentElement.style.overflow = "";
    }, 240);
  };

  if (!customElements.get("el-popup")) {
    class ElPopup extends HTMLElement {
      connectedCallback() {
        if (this._popupReady) return;
        this._popupReady = true;

        this.setAttribute("role", "button");
        this.setAttribute("tabindex", "0");

        this.addEventListener("click", () => this.openPopup());

        this.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            this.openPopup();
          }
        });
      }

      openPopup() {
        const triggerName = this.getAttribute("data-popup-trigger");
        if (!triggerName) return;

        const escapedTrigger =
          window.CSS && CSS.escape ? CSS.escape(triggerName) : triggerName;

        const popup = document.querySelector(
          `[data-popup-content="${escapedTrigger}"]`,
        );
        if (!popup) return;

        openPopup(popup);

        popup.querySelectorAll("[data-popup-close]").forEach((button) => {
          button.onclick = () => closePopup(popup);
        });

        const closeOnEscape = (event) => {
          if (event.key === "Escape" && !popup.hidden) {
            closePopup(popup);
            document.removeEventListener("keydown", closeOnEscape);
          }
        };

        document.addEventListener("keydown", closeOnEscape);
      }
    }

    customElements.define("el-popup", ElPopup);
  }
})();
